import { Text, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { CbButton } from '../..';
export interface CbParticipantCardHeaderProps {
  listLength: number;
  title: string;
  buttonText: string;
  ariaLabel: string;
  btnColor: string;
  btnBackgroundColor?: string;
  customTeamTitleColor?: string;
  hideButton?: boolean;
  hoverColor: string;
  handleClick: () => void;
}
export const CbParticipantCardHeader: FC<CbParticipantCardHeaderProps> = ({
  listLength,
  title,
  buttonText,
  btnColor,
  hideButton,
  btnBackgroundColor,
  customTeamTitleColor,
  ariaLabel,
  handleClick,
  hoverColor
}) => {
  return <Flex paddingRight={4} justifyContent="space-between" width="100%" marginTop={6} marginLeft={1} data-sentry-element="Flex" data-sentry-component="CbParticipantCardHeader" data-sentry-source-file="CbPaticipantPickerHeader.tsx">
      <Text fontSize={{
      md: customTeamTitleColor ? '15px' : '16px'
    }} fontFamily="codenext" color={customTeamTitleColor || 'luigisPants.500'} fontWeight="bold" marginBottom={-1} data-sentry-element="Text" data-sentry-source-file="CbPaticipantPickerHeader.tsx">
        {`${title} (${listLength})`}
      </Text>
      {!hideButton && <CbButton aria-label={ariaLabel} background={btnBackgroundColor} paddingLeft={6} paddingRight={6} borderColor="cloud.400" shadow={'none'} height={'30px'} fontSize={'12px'} color={btnColor} _hover={{
      backgroundColor: hoverColor
    }} onClick={handleClick}>
          {buttonText}
        </CbButton>}
    </Flex>;
};